import type {
  CallRouteAttemptOutcome,
  CallRouteStage,
  CallRouteTrace,
} from './types';

export function formatRouteWait(value: number): string {
  const seconds = Math.max(0, Math.floor(Number(value) || 0));
  if (seconds < 60) return `${seconds} сек`;
  const minutes = Math.floor(seconds / 60);
  return `${minutes} мин ${String(seconds % 60).padStart(2, '0')} сек`;
}

export function callRouteAttemptLabel(outcome: CallRouteAttemptOutcome): string {
  const labels: Record<CallRouteAttemptOutcome, string> = {
    RINGING: 'Звонит',
    ANSWERED: 'Ответил',
    ANSWERED_ELSEWHERE: 'Принят другим сотрудником',
    TRANSFERRED: 'Переведён',
    NO_ANSWER: 'Без ответа',
    CANCELLED: 'Отменён',
    FAILED: 'Ошибка',
    COMPLETED: 'Разговор завершён',
    UNKNOWN: 'Результат не определён',
  };
  return labels[outcome] || labels.UNKNOWN;
}

export function callRouteStageLabel(outcome: CallRouteStage['outcome']): string {
  const labels: Record<CallRouteStage['outcome'], string> = {
    RINGING: 'Вызов идёт',
    ANSWERED: 'Есть ответ',
    ANSWERED_ELSEWHERE: 'Ответ на другом этапе',
    TRANSFERRED: 'Переведён',
    NO_ANSWER: 'Без ответа',
    CANCELLED: 'Отменён',
    FAILED: 'Ошибка',
    COMPLETED: 'Завершён',
    UNKNOWN: 'Результат не определён',
    MISSED: 'Пропущен',
  };
  return labels[outcome] || labels.UNKNOWN;
}

export function callRouteStrategyLabel(strategy: CallRouteStage['strategy']): string {
  if (strategy === 'RING_ALL') return 'Всем одновременно';
  if (strategy === 'SEQUENTIAL') return 'Последовательно';
  return 'Прямое соединение';
}

function answeredName(trace: CallRouteTrace): string {
  const name = String(trace.answeredBy?.name || '').trim();
  if (name) return name;
  const extension = String(trace.answeredBy?.extension || '').trim();
  return extension ? `доб. ${extension}` : '';
}

export function callRouteSummary(trace?: CallRouteTrace | null): string {
  if (!trace || trace.kind === 'LEGACY') return 'Маршрут не фиксировался';
  const answer = answeredName(trace);
  if (trace.kind === 'DIRECT') return answer ? `Прямой звонок · ${answer}` : 'Прямой звонок';

  const groups: string[] = [];
  for (const stage of trace.stages) {
    const name = String(stage.groupName || '').trim();
    if (name && name !== 'Группа не определена' && groups.at(-1) !== name) groups.push(name);
  }
  const parts = [...groups];
  if (answer && parts.at(-1) !== answer) parts.push(answer);
  return parts.length ? parts.join(' → ') : 'Управляемый маршрут';
}
